import type { ComponentProps } from 'react';
import { cn } from '@/shared/lib/cn';
import { maskCurrency } from '@/shared/lib/input-masks';
import { Input } from '@/shared/ui/input';

interface UsdInputProps extends Omit<ComponentProps<typeof Input>, 'value' | 'onChange' | 'inputMode'> {
  /** Texto mascarado ("1.234,50"); converta com `parseUsdText`. */
  value: string;
  onValueChange: (text: string) => void;
}

/** Valor em dólar com máscara de centavos enquanto digita. */
export function UsdInput({ value, onValueChange, className, ...props }: UsdInputProps) {
  return (
    <div className="relative">
      <Input
        {...props}
        inputMode="numeric"
        value={value}
        onChange={(e) => onValueChange(maskCurrency(e.target.value))}
        className={cn('pl-12', className)}
      />
      {/* Depois do input: o backdrop-blur do campo borraria o prefixo se ele ficasse atrás. */}
      <span className="pointer-events-none absolute left-3.5 top-1/2 z-10 -translate-y-1/2 text-sm font-medium text-foreground/70">
        US$
      </span>
    </div>
  );
}
